// extracted by mini-css-extract-plugin
export default {"license-icons":"gV4c9","licenseIcons":"gV4c9"};